import React from 'react'
import EmbedNode from '../EmbedNode'

export default function LoomNode({id,data,selected,...props}) {
    return (
        <EmbedNode domain='loom.com' className='aspect-video' text='Loom Link' transformUrl={(url) => url.replace('share','embed')} id={id} data={data} selected={selected} {...props} />
    )
}
